import React from "react";

const testimonials = [
  {
    id: 1,
    name: "Anjali Sharma",
    role: "Bride-to-be",
    content: "I felt like an absolute royalty on my wedding day. The antique bridal set was detailed and perfectly matched my lehenga. Outstanding craftsmanship!",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&q=80&w=150"
  },
  {
    id: 2,
    name: "Ravi Verma",
    role: "Regular Customer",
    content: "Bought a diamond necklace for our anniversary. The sparkle is brilliant, and the certification gave me so much peace of mind. Highly recommended.",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&q=80&w=150"
  },
  {
    id: 3,
    name: "Sunita Rao",
    role: "Jewelry Enthusiast",
    content: "Their lifetime exchange policy is fantastic. I upgraded my old set to a new polki design with zero hassle. Beautiful collection and great service.",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&q=80&w=150"
  }
];

const TestimonialsNew = () => {
  return (
    <div className="w-full bg-[#fdfaf5] py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        
        <p className="text-[#D4AF37] text-md font-serif mb-2">01</p>
        <h2 className="text-3xl md:text-4xl font-serif text-[#3B291A] mb-3">
          Review Your Journey
        </h2>
        <p className="text-gray-500 text-sm uppercase tracking-widest mb-12">
          From smiles to sparkle, we are there with you, forever...
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {testimonials.map((item) => (
            <div 
              key={item.id} 
              className="bg-white border border-[#eae0d5] p-8 text-left shadow-sm hover:shadow-md transition-shadow relative"
            >
              {/* Quotation mark decoration */}
              <div className="absolute top-4 right-6 text-6xl text-[#f4eee6] font-serif leading-none">
                "
              </div>
              
              <div className="flex items-center gap-4 mb-6">
                <img 
                  src={item.image} 
                  alt={item.name} 
                  className="w-14 h-14 rounded-full object-cover border border-[#D4AF37]"
                />
                <div>
                  <h4 className="text-[#3B291A] font-bold text-sm tracking-wide">{item.name}</h4>
                  <p className="text-gray-500 text-xs">{item.role}</p>
                </div>
              </div>
              
              {/* Star Rating */}
              <div className="flex text-[#D4AF37] mb-4 text-sm gap-1">
                {'★★★★★'}
              </div>

              <p className="text-gray-600 text-sm leading-relaxed italic relative z-10">
                "{item.content}"
              </p>

              <div className="mt-6">
                 <button className="text-[#D4AF37] text-xs font-semibold hover:text-[#B8982D] transition-colors flex items-center gap-1 uppercase tracking-wider">
                   Read full review
                 </button>
              </div>
            </div>
          ))}
        </div>
        
        {/* Statistics or feature box under testimonials */}
        <div className="mt-12 md:mt-16 w-full max-w-4xl mx-auto bg-white border border-[#D4AF37] p-6 lg:p-8 flex flex-col md:flex-row justify-around items-center gap-6 shadow-sm">
           <div className="text-center">
              <h3 className="text-[#D4AF37] text-xl font-bold font-serif">10K+</h3>
              <p className="text-[#3B291A] text-sm uppercase tracking-wider font-semibold">Happy Clients</p>
           </div>
           <div className="hidden md:block w-px h-12 bg-[#eae0d5]"></div>
           <div className="text-center">
              <h3 className="text-[#D4AF37] text-xl font-bold font-serif">4.9/5</h3>
              <p className="text-[#3B291A] text-sm uppercase tracking-wider font-semibold">Google Rating</p>
           </div>
           <div className="hidden md:block w-px h-12 bg-[#eae0d5]"></div>
           <div className="text-center">
              <h3 className="text-[#D4AF37] text-xl font-bold font-serif">24/7</h3>
              <p className="text-[#3B291A] text-sm uppercase tracking-wider font-semibold">Customer Support</p>
           </div>
        </div>
      </div>
    </div>
  );
};

export default TestimonialsNew;
